export default __webpack_public_path__ + "static/media/activity_context.a3171f73.png";